import { useEffect, useRef, useState } from 'preact/hooks';

export const useIsDragging = () => {
  const elementRef = useRef();
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [isMouseMoving, setIsMouseMoving] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    elementRef.current.addEventListener('mousedown', () => {
      setIsMouseDown(true);
      setIsMouseMoving(false);
    });
    elementRef.current.addEventListener('mousemove', () => {
      if (!isMouseMoving) {
        setIsMouseMoving(true);
      }
    });
    elementRef.current.addEventListener('mouseup', () => {
      setIsMouseDown(false);
      setIsMouseMoving(false);
      setTimeout(() => {
        setIsDragging(false);
      }, 100);
    });

    return () => {
      elementRef.current.removeEventListener('mousedown');
      elementRef.current.removeEventListener('mousemove');
      elementRef.current.removeEventListener('mouseup');
    };
  }, []);

  useEffect(() => {
    if (!isDragging && isMouseDown && isMouseMoving) {
      setIsDragging(true);
    }
  }, [isMouseDown, isMouseMoving]);

  return [elementRef, isDragging];
};
